import { AvailableOrganizerDataMapper } from 'modules/organizers/domain/data-mappers/available-organizer.data-mapper';
import { AvailableOrganizerDto } from 'modules/organizers/domain/interfaces/available-organizer-dto';
import { AvailableOrganizer } from 'modules/organizers/domain/interfaces/available-organizer';
import { restApi } from 'shared/api/rest-api';

/**
 * Организации, доступные вошедшему пользователю. Лежит в `organizers`, а не в
 * `auth`: сущность здесь — организация-тенант, а не пользователь. Экран выбора
 * (`/select-tournament`) остаётся частью флоу входа и просто использует этот эндпоинт.
 *
 * Рядом, в `organizers-api.ts`, живут GraphQL-запросы про организации; этот —
 * единственный REST, поэтому инжектится в `restApi`.
 */
export interface ListAvailableOrganizersArgs {
  limit: number;
  offset: number;
  namePart?: string;
}

const availableOrganizersApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    listAvailableOrganizers: build.query<AvailableOrganizer[], ListAvailableOrganizersArgs>({
      query: ({ limit, offset, namePart }) => ({
        url: '/tournaments',
        method: 'GET',
        params: { limit, offset, ...(namePart ? { namePart } : {}) },
      }),
      transformResponse: (raw: AvailableOrganizerDto[]): AvailableOrganizer[] => {
        const mapper = new AvailableOrganizerDataMapper();
        return (raw ?? []).map((dto) => mapper.decode(dto));
      },
      providesTags: (result) =>
        result && result.length
          ? [
              ...result.map((organizer) => ({ type: 'Tournament' as const, id: organizer.id })),
              { type: 'Tournament' as const, id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Tournament' as const, id: 'PARTIAL-LIST' }],
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useListAvailableOrganizersQuery } = availableOrganizersApi;

export default availableOrganizersApi;
